import { oc } from '@orpc/contract';
import { templateParamCatalogOutputSchema } from '../schemas/templates.schemas.js';
/** The engine's catalogue: keys, groups, labels, units, defaults and validation bounds (plan §5.10). */
export const getTemplateParamCatalogContract = oc
    .route({
    method: 'GET',
    path: '/templates/param-catalog',
    tags: ['Templates'],
    summary: 'The template parameter catalogue',
})
    .output(templateParamCatalogOutputSchema);
//# sourceMappingURL=get-template-param-catalog.contract.js.map